import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

const FeaturedWork = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/case-studies").then((r) => setItems(r.data.slice(0, 3))).catch(() => {});
    }, []);

    return (
        <section
            data-testid="featured-work-section"
            className="bg-[var(--st-cream)] relative z-10 py-24 lg:py-36"
        >
            <div className="st-container">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16 lg:mb-20">
                    <div>
                        <p className="eyebrow mb-5 text-[var(--st-gold-deep)]">03 — Selected work</p>
                        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl">
                            Brands we've<br /> <span className="italic">quietly shaped.</span>
                        </h2>
                    </div>
                    <Link to="/work" data-testid="featured-work-cta" className="btn-ghost">
                        View all projects <ArrowUpRight size={16} />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {items.map((cs, i) => (
                        <motion.article
                            key={cs.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.12 }}
                            data-testid={`featured-work-card-${cs.slug}`}
                            className="group"
                        >
                            <Link to={`/work/${cs.slug}`} className="block">
                                <div className="relative aspect-[4/5] overflow-hidden bg-[var(--st-ink)] mb-6 border border-[rgba(180,153,90,0.25)]">
                                    <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center">
                                        <div className="absolute inset-6 border border-[rgba(180,153,90,0.35)]" />
                                        <div className="absolute inset-6 border-t-2 border-b-2 border-[var(--st-gold)]/0 group-hover:border-[var(--st-gold)]/60 transition-all duration-700" />
                                        <p className="eyebrow text-[var(--st-gold)] mb-6 z-10">
                                            Case · {String(i + 1).padStart(2, '0')}
                                        </p>
                                        <div className="flex items-center gap-3 mb-8 z-10">
                                            <span className="block h-px w-8 bg-[var(--st-gold)]/60" />
                                            <span className="w-1.5 h-1.5 rounded-full bg-[var(--st-gold)]" />
                                            <span className="block h-px w-8 bg-[var(--st-gold)]/60" />
                                        </div>
                                        <h3 className="font-serif text-3xl md:text-4xl leading-[1.05] tracking-tight text-[var(--st-gold)] z-10 max-w-[85%]">
                                            {cs.client}
                                        </h3>
                                        <p className="font-serif italic text-sm text-[#c8c5b3] mt-6 z-10 max-w-[80%] line-clamp-2">
                                            {cs.tagline}
                                        </p>
                                        <div className="absolute bottom-8 left-0 right-0 flex items-center justify-center gap-2 eyebrow text-[var(--st-cream)] opacity-70 group-hover:opacity-100 group-hover:text-[var(--st-gold)] transition-all duration-500 z-10">
                                            View case study <ArrowUpRight size={13} />
                                        </div>
                                    </div>
                                </div>
                                <div className="border-t border-[var(--st-line)] pt-4">
                                    <p className="eyebrow text-[var(--st-gold-deep)] mb-2">
                                        {cs.industry} · {cs.year}
                                    </p>
                                    <h4 className="font-serif text-2xl leading-tight group-hover:text-[var(--st-gold-deep)] transition-colors duration-500">
                                        {cs.client}
                                    </h4>
                                </div>
                            </Link>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedWork;
